import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { auth } from '../api/methods';
import { getUserCapabilities } from '../constants';
export const authKeys = {
    me: ['auth', 'me'],
};
export function useCurrentUser() {
    return useQuery({
        queryKey: authKeys.me,
        queryFn: () => auth.getMe(),
        staleTime: 60 * 1000, // 1 minute
        refetchOnWindowFocus: true, // Re-check auth when returning from external flows (Trello OAuth, tab switch)
        refetchOnMount: 'always',
        retry: false,
    });
}
export function useCurrentUserCapabilities() {
    const query = useCurrentUser();
    const user = query.data?.status === 'active' ? query.data.user : null;
    return {
        ...query,
        capabilities: user ? getUserCapabilities(user) : null,
    };
}
export function useLogin() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ email, password }) => auth.signIn(email, password),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: authKeys.me });
        },
    });
}
export function useLogout() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: () => auth.logout(),
        onSuccess: () => {
            queryClient.clear();
        },
    });
}
export function useForgotPassword() {
    return useMutation({
        mutationFn: ({ email, redirectTo }) => auth.forgotPassword(email, redirectTo),
    });
}
export function useResetPassword() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ code, password }) => auth.resetPassword(code, password),
        onSuccess: (data) => {
            if (!data.noAccess) {
                queryClient.invalidateQueries({ queryKey: authKeys.me });
            }
        },
    });
}
//# sourceMappingURL=useAuth.js.map